import { RegistrationType } from '@exam-center/graphql';

import { BaseSearchSelection } from '../base-search-selection';

const REGISTRATION_TYPE_OPTIONS = [
  { label: 'Public', value: RegistrationType.Public },
  { label: 'In-house', value: RegistrationType.InHouse },
];

interface RegistrationTypeSearchSelectionProps {
  value: { label: string; value: RegistrationType }[];
}

export default function RegistrationTypeSearchSelection(
  props: Readonly<RegistrationTypeSearchSelectionProps>,
) {
  const { value } = props;

  return (
    <BaseSearchSelection
      name='registrationType'
      options={REGISTRATION_TYPE_OPTIONS}
      label='Registration Type'
      value={value}
    />
  );
}
